import React from 'react'
import head from 'lodash/head'
import { domToReact } from 'html-react-parser'
import filter from 'tcweb-material-components/core/poly/filter'
import get from 'tcweb-material-components/core/poly/get'
import Grid from 'tcweb-material-components/core/grid'
import { makeStyles } from '@material-ui/styles'
import classnames from 'classnames'

import { cleanWPValue } from '../../utilities/wpOptions'

const SCROLL_BREAKPOINTS = {
    mobile: 'xs',
    tablet: 'sm',
    desktop: 'md'
}
const GRID_VERTICAL_ALIGNMENTS = {
    'are-vertically-aligned-center': 'center',
    'are-vertically-aligned-top': 'flex-start',
    'are-vertically-aligned-bottom': 'flex-end'
}

const getGridVerticalAlignment = attribs => {
    const alignmentClass = head(get(attribs, 'class', '').match(/are-vertically-aligned-[a-z]+/gi))
    return GRID_VERTICAL_ALIGNMENTS[alignmentClass]
}

const useClasses = makeStyles(theme => ({
    grid: ({ data, gridVerticalAlignment = 'initial', isWPColumn }) => ({
        columnGap: cleanWPValue(get(data, 'grid.mobile.gapCol')),
        rowGap: cleanWPValue(get(data, 'grid.mobile.gapRow')),
        [theme.breakpoints.up('sm')]: {
            columnGap: cleanWPValue(get(data, 'grid.tablet.gapCol')),
            rowGap: cleanWPValue(get(data, 'grid.tablet.gapRow')),
        },
        [theme.breakpoints.up('md')]: {
            columnGap: cleanWPValue(get(data, 'grid.desktop.gapCol')),
            rowGap: cleanWPValue(get(data, 'grid.desktop.gapRow')),
        },
        alignItems: gridVerticalAlignment,
        '& .wp-block-column': { margin: '0 !important' } // Overwrite .wp-block-column:not(:first-child) when in uniform grid
    }),
    item: {
        display: 'flex',
        flexDirection: 'column'
    }
}))

const createDataObject = (cols) => {
    return {
        has: { mobile: {featured: false }},
        col: {
            mobile: { number: 1 },
            tablet: { number: cols },
            desktop: { number: cols }
        },
        grid: {
            mobile: { gapCol: '10px', gapRow: '10px' },
            tablet: { gapCol: '20px', gapRow: '20px' },
            desktop: { gapCol: '30px', gapRow: '30px' }
        }
    }
}

const ColumnsSwap = ({ children, options, data, attribs, className }) => {
    const filteredChildren = filter(child => child.type !== 'text', children)
    const isUniformGrid = Object.keys(data).length !== 0
    const _data = isUniformGrid ? data : createDataObject(filteredChildren.length)
    const blockWidth = head(get(attribs, 'class', '').match(/alignfull|alignwide/g))
    const backgroundColor = head(get(attribs, 'class', '').match(/has-gears-[a-z]+-background-color/gi))
    const textColor = head(get(attribs, 'class', '').match(/has-gears-[a-z]+-color/gi))
    const _classes = useClasses({ data: _data, gridVerticalAlignment: getGridVerticalAlignment(attribs) })

    return (
        <Grid
            scrollOn={SCROLL_BREAKPOINTS[get(_data, 'horizontal.mobile.scroll', 'xs')]}
            cols={{
                xs: get(_data, 'col.mobile.number', 1),
                sm: get(_data, 'col.tablet.number', 1),
                md: get(_data, 'col.desktop.number', 3)
            }}
            reverse={get(_data, 'reverse.mobile.items', false)}
            featureFirst={get(_data, 'has.mobile.featured', false)}
            classes={{ root: classnames(_classes.grid, blockWidth, backgroundColor, textColor, className )}}

        >
            {filteredChildren.map((child, index) => (
                    <div key={`column-${index + 1}`} className={classnames(_classes.item, child.attribs.class)}>
                        {domToReact(child.children, options)}
                    </div>
                )
            )}
        </Grid>
    )
}

export default ColumnsSwap
